<soft-op-diagram-tabelle-view
  [offenePosten]="offenePosten()"
  [loading]="loading()"
  [error]="error()"
  [color]="'var(--colorSuccess600)'"
  [showExtraColumn]="true"
  [title]="'#OFFENE_POSTEN.DEBITOREN_TITLE'"
  [subtitle]="'#OFFENE_POSTEN.DEBITOREN_SUB_TITLE'">
</soft-op-diagram-tabelle-view>
